import { Plugin } from "../types";

export const LoggerPlugin: Plugin = {
  name: "logger",
  setup(sdk) {
    sdk.http.use({
      onRequest: (req: any) => {
        console.log("[GMM Request]", req.method, req.url);
        return req;
      },
      onResponse: (res: any) => {
        console.log("[GMM Response]", res);
        return res;
      },
      onError: (err: any) => {
        console.error("[GMM Error]", err.message);
      },
    });
  },
};
